"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tintIconSvgDataUri = exports.NEUTRAL_STROKE = exports.EMAIL_ICON_CID = exports.EMAIL_ICON_SVG = exports.EMAIL_ICON_DATA_URI = exports.EMAIL_ICON_BASE64 = void 0;
const icons_generated_1 = require("./icons.generated");
var icons_generated_2 = require("./icons.generated");
Object.defineProperty(exports, "EMAIL_ICON_BASE64", { enumerable: true, get: function () { return icons_generated_2.EMAIL_ICON_BASE64; } });
Object.defineProperty(exports, "EMAIL_ICON_DATA_URI", { enumerable: true, get: function () { return icons_generated_2.EMAIL_ICON_DATA_URI; } });
Object.defineProperty(exports, "EMAIL_ICON_SVG", { enumerable: true, get: function () { return icons_generated_2.EMAIL_ICON_SVG; } });
exports.EMAIL_ICON_CID = {
    dafFacebook: "cid:icon-daf-facebook",
    dafLinkedin: "cid:icon-daf-linkedin",
    dafInstagram: "cid:icon-daf-instagram",
    dafQuote: "cid:icon-daf-quote",
    calendar: "cid:icon-calendar",
    pin: "cid:icon-pin",
    edit: "cid:icon-edit",
    heart: "cid:icon-heart",
    externalLink: "cid:icon-external-link",
    zeffyLight: "cid:icon-zeffy-light",
    zeffyDark: "cid:icon-zeffy-dark",
    zeffyDarkGreenWind: "cid:icon-zeffy-dark-green-wind",
    giftAidLight: "cid:icon-giftaid-light",
    giftAidDark: "cid:icon-giftaid-dark",
    checkInManager: "cid:img-check-in-manager",
    googlePlayBadge: "cid:img-google-play-badge-en",
    googlePlayBadgeFr: "cid:img-google-play-badge-fr",
    googlePlayBadgeDe: "cid:img-google-play-badge-de",
    appStoreBadge: "cid:img-app-store-badge-en",
    appStoreBadgeFr: "cid:img-app-store-badge-fr",
    appStoreBadgeDe: "cid:img-app-store-badge-de",
    creditCard: "cid:icon-credit-card",
    scan: "cid:icon-scan",
    flash: "cid:icon-flash",
};
exports.NEUTRAL_STROKE = "#667085";
const tintIconSvgDataUri = (icon, strokeColor) => {
    const tinted = icons_generated_1.EMAIL_ICON_SVG[icon].split(exports.NEUTRAL_STROKE).join(strokeColor);
    return `data:image/svg+xml,${encodeURIComponent(tinted)}`;
};
exports.tintIconSvgDataUri = tintIconSvgDataUri;
